module.exports = __webpack_public_path__ + "static/img/anxun53.f2a67656.png";